export const APP_NAME = 'requestProposal';
